module.exports = __webpack_public_path__ + "6e9d231d85c0b67e7077b5eb754212f8.png";